import { spacing } from '@hubble/tokens/web';
import { Flex } from '../../Flex/index.js';
import { ScreenReaderOnly } from '../../ScreenReaderOnly/index.js';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';

const ModalHeader = ({
  children,
  back,
  close,
  variant = 'start'
}) => {
  if (variant === 'start') {
    return jsxs(Flex, {
      padding: spacing[24],
      paddingBottom: spacing[16],
      gap: spacing[12],
      "data-header": true,
      children: [jsxs(Flex, {
        flexDirection: "column",
        alignItems: "start",
        flex: "1",
        gap: spacing[4],
        children: [back && jsx(Flex, {
          mb: 1.5,
          children: back
        }), children]
      }), close]
    });
  }
  if (variant === 'inline') {
    return jsxs(Flex, {
      padding: spacing[24],
      paddingBottom: spacing[16],
      gap: spacing[8],
      "data-header": true,
      children: [back, jsx(Flex, {
        flexDirection: "row",
        alignItems: "center",
        flex: "1",
        gap: spacing[8],
        children: children
      }), close]
    });
  }
  if (variant === 'center') {
    return jsxs(Flex.Column, {
      padding: spacing[24],
      paddingBottom: spacing[16],
      gap: spacing[12],
      "data-header": true,
      children: [jsxs(Flex, {
        justifyContent: "space-between",
        children: [back, close]
      }), jsx(Flex, {
        flexDirection: "column",
        alignItems: "center",
        flex: "1",
        gap: spacing[4],
        children: children
      })]
    });
  } else {
    return jsxs(Flex, {
      padding: spacing[24],
      paddingBottom: spacing[16],
      gap: spacing[12],
      "data-header": true,
      children: [jsxs(Flex, {
        flexDirection: "column",
        alignItems: "start",
        flex: "1",
        gap: spacing[4],
        children: [back, jsx(ScreenReaderOnly, {
          children: children
        })]
      }), close]
    });
  }
};

export { ModalHeader };
